import { createApp } from 'vue'
import App from './App.vue'
import { EventBus } from '@/assets/script/event-bus'

import store from './store'
import router from './router'
import axios from 'axios'

// import font awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faEye as faEyeRegular, faEyeSlash as faEyeSlashRegular } from '@fortawesome/free-regular-svg-icons'


// PrimeVue
import PrimeVue from 'primevue/config'
import 'primevue/resources/themes/saga-blue/theme.css'   // theme, boleh ganti misalnya nova, etc.
import 'primevue/resources/primevue.min.css'            // core css
import 'primeicons/primeicons.css'                      // icons
import 'primeflex/primeflex.css'                         // kalau mau pakai primeflex
import Button from 'primevue/button'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from 'primevue/dialog'

import constants from './constants.js';


// tambahkan icon ke library
library.add(faEyeRegular, faEyeSlashRegular)

//axios check base url API
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL
axios.defaults.headers.common['client_id'] = process.env.VUE_APP_CLIENT_ID  
axios.defaults.headers.common['client_secret'] = process.env.VUE_APP_CLIENT_SECRET
axios.interceptors.request.use(config => {
  const token = store.getters.getToken
  if (token) {
    config.headers.Authorization = 'Bearer ' + token
  }
  return config
})

//Import own style
import '@/assets/css/custom.css';






const app = createApp(App)

app.use(PrimeVue)  // pasang PrimeVue
app.component('font-awesome-icon', FontAwesomeIcon)
app.config.globalProperties.$axios = axios //globalkan axios
app.component('PvButton', Button)
app.component('PvDataTable', DataTable)
app.component('PvColumn', Column)
app.component('PvDialog', Dialog)

constants.setGlobalProps(app);

app.config.globalProperties.$bus = EventBus

app.use(router).use(store)
app.mount('#app')


// Load token async tanpa delay mount
store.dispatch('loadUser').then(() => {
  axios.interceptors.request.use(config => {
    const token = store.getters.getToken
    if (token) {
      config.headers.Authorization = 'Bearer ' + token
    }
    return config
  })
})